// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../css/" + "styles" + "." + "a086d7d854b8323d240e" + ".css";
};